import { Component, Input, Output, EventEmitter} from '@angular/core'

@Component({
  selector: 'app-st-textarea',
  templateUrl: './st-textarea.component.html',
  styleUrls: ['./st-textarea.component.scss'],
  standalone: false
})
export class StTextAreaComponent {

  @Input()
  label = 'FIELD LABEL';

  @Input()
  idVal: string = 'textId';

  @Input()
  inputVal: string = '';

  @Input()
  placeHolderVal = 'Type here';

  @Input()
  disabled: boolean = false;

  @Input()
  width?: string;

  @Input()
  rows: number = 10;

  @Input()
  cols: number = 100;

  @Input()
  backgroundColor: string = '#ffffff';

  @Input()
  fontColor: string = '#000000';

  @Input()
  requiredVal: boolean = false;

  @Output()
  onClick = new EventEmitter<Event>();
}
